import PropTypes from 'prop-types';
import React from 'react';
import {
  FormGroup,
  InputGroup,
  ButtonGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
  Modal
} from 'react-bootstrap';
import { Field } from 'redux-form';
import update from 'immutability-helper';
import diff from 'object-diff';
import moment from 'moment';
import HotelsListTable from './HotelsListTable';
import Script from 'react-load-script';

import EventDetail from './EventDetail';
import EventDetailForm from './EventDetailForm';


function getInitialValues(event, initialDate) {
  // Shim place obj to work with redux-form better
  const isNewEvent = event.id ? false : true;
  // For new event initial date will set to latest event date.
  if(isNewEvent && !event.isAddEventFromCalendar){
    event['start'] = initialDate;
    event['end'] = initialDate;
  }
  return event;
}
const normalizeDate = value => {
  if (Object.prototype.hasOwnProperty.call(value, 'value')) {
    return value.value.format('YYYY-MM-DD');
  }
  if (moment.isMoment(value)) {
    return value.format('YYYY-MM-DD');
  }
  return value;
};

//isUpdate array to diffrentiate between button click of update or cancel.
let isUpdate = []
let isCalledFromCancel = false;
let hotels = []
class EventDetailModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleAddEvent             = this.handleAddEvent.bind(this);
    this.handleEditEvent            = this.handleEditEvent.bind(this);
    this.handleRemoveEvent          = this.handleRemoveEvent.bind(this);
    this.showConfirmForRemoveEvent  = this.showConfirmForRemoveEvent.bind(this);
    this.showConfirmForEditEvent    = this.showConfirmForEditEvent.bind(this);
    this.closeModal                 = this.closeModal.bind(this);
    this.closeEditModal             = this.closeEditModal.bind(this);
    this.handleSubmit               = this.handleSubmit.bind(this);
    this.handleConfirmUpdate        = this.handleConfirmUpdate.bind(this);
    this.addFlagForCancel           = this.addFlagForCancel.bind(this);
    this.handleShowHotelsList       = this.handleShowHotelsList.bind(this);
    this.closeHotelsListModal       = this.closeHotelsListModal.bind(this);
    this.handleLocationChange       = this.handleLocationChange.bind(this);
    this.handleAdvanceSearch        = this.handleAdvanceSearch.bind(this);
    this.handleLocationChangeAdvanceSearch = this.handleLocationChangeAdvanceSearch.bind(this);

    const isNew = this.props.event.id ? false : true;
    let place = null, google_place_id = null, inputValue = null;
    if (!isNew) {
      place = props.event.place.name
      inputValue = props.event.name
      google_place_id = props.event.place.google_place_id
    }
    this.state = {
      place               : place,
      inputValue          : inputValue,      
      google_place_id     : google_place_id,
      eventIdForRef       : 0,
      eventDetail         : [],
      bidDetals           :[],
      showConfirmForRemove: false,
      showConfirmForEdit  : false,
      modalText           : '',
      isCallFromUpdateButton: false,
      isCallFromUpdate : false,
      showHotelsList : false,
      searchText : place,
      isLoading : false,
      advanceSearchText : '',
      latestEventDate: moment(moment.now()).add(1,'days'),
      proposalFetched:false
    }
  }
  componentDidMount() {
    try {
      // Fetch proposals data
      this.setState({
        proposalFetched:true
      })
  
      // Once proposals are fetched, proceed with the rest of the logic
      let events = this.props.tourStops;
      let latestEventDate = events[events.length - 1].end;
      latestEventDate = moment(latestEventDate).add(1, 'days');
      this.setState({
        latestEventDate: latestEventDate
      });
    } catch (error) {
      // Handle error if requestProposals fails
      console.error('Error fetching proposals:', error);
    }
  }
  
  handleSubmit(values) {
    const initialValues = getInitialValues(this.props.event, this.state.latestEventDate);
    const isNew = this.props.event.id ? false : true;
    values.name = this.state.inputValue;


    if (isNew) {
      return this.handleAddEvent(values, initialValues);
    }
    return this.handleEditEvent(values, initialValues);
  }  

  handleAddEvent(values, initialValues) {
    const submitValues = values;
    submitValues.tour = this.props.tourId;

    if (this.state.google_place_id) {
      submitValues.place = {
        name: this.state.place,
        google_place_id: this.state.google_place_id
      };
    } else {
      alert("Please select venue by searching using search button");
      return false;
    }
    if (submitValues.end) {
      submitValues.end = normalizeDate(submitValues.end);
    }
    if (submitValues.start) {
      submitValues.start = normalizeDate(submitValues.start);
    }
    if(values.start == null || values.end == null){
      alert("Please select a valid date range")
      return
    }
    // if (this.props.event.event_type !== 'stay' && submitValues.start) {
    //   submitValues.end = submitValues.start;
    // }
    this.props.addEvent(submitValues, (response) =>{
      //Do nothing
    });
    this.props.onClose();
  }

  handleEditEvent(values, initialValues) {
    const changedValues = diff(initialValues, values);
    const submitValues = changedValues;
    if (initialValues.place.google_place_id != this.state.google_place_id) {
      submitValues.place = {
        name: this.state.place,
        google_place_id: this.state.google_place_id
      };
    }

    if (submitValues.end) {
      submitValues.end = normalizeDate(submitValues.end);
    }
    if (submitValues.start) {
      submitValues.start = normalizeDate(submitValues.start);
    }
    // TODO: Handle if start is modified, set end to same value
    // if (this.props.event.event_type !== 'stay' && submitValues.start) {
    //   submitValues.end = submitValues.start;
    // }
    if(values.start == null || values.end == null){
      alert("Please select a valid date range")
      return
    }
    submitValues.isCallFromUpdate = isUpdate.includes('Update') ? true : false;
    submitValues.eventType = this.props.event.event_type;
    this.props.updateEventStay(this.props.event.id, submitValues,(response) =>{
     if(response.event) {
       this.props.updateRoute(response.event);
      }
       this.props.updateRoute(response);

      isUpdate = [];
      this.props.onClose();
    });
  }

  handleRemoveEvent() {
    const payload = {
      isCalledFromCancelFlag: isCalledFromCancel,
      event_type: typeof(this.state.eventDetail.event_type) != 'undefined' ? this.state.eventDetail.event_type : '',
      tour_id: this.props.tourId
    };

    this.props.removeEvent(this.state.eventIdForRef, payload, (response) => {
      this.setState({
        eventIdForRef: 0,
        showConfirmForRemove: false,
        modalText: ''
      })
      isCalledFromCancel = false;
      this.props.onClose();
    });
  }

  //Show the confirmation for remove event
  showConfirmForRemoveEvent(){
    if(typeof(this.props.event.event_type) != 'undefined' && this.props.event.event_type == 'stay'){
      this.setState({
        eventIdForRef: this.props.event.id,
        eventDetail: this.props.event
      });     

     setTimeout(() => {
        this.handleRemoveEvent(); 
      }, 1000);
          
    }else{
      this.setState({
        eventIdForRef: this.props.event.id,
        eventDetail: this.props.event,
        showConfirmForRemove: true,
        modalText: 'Do you want to Delete the stays for this event as well?'
      });
    }    
  }

  addFlagForCancel() {
    isCalledFromCancel = true;
    this.handleRemoveEvent();
  }

  //Show the confirmation for edit event
  showConfirmForEditEvent(values){
    this.setState({
      showConfirmForEdit: true
    })
  }
  
  handleConfirmUpdate(){
    isUpdate.push('Update');
    document.getElementById("stayUpdateConfirmButton").click();
  }

  //Close modal popup action
  closeModal(){
    this.setState({
      eventIdForRef: 0,
      showConfirmForRemove: false,
      modalText: ''
    })
  }

  closeEditModal(){
    this.setState({
      showConfirmForEdit: false
    })
  }

  handlePlaceTextBoxChange = (event) => {
    this.setState({ place: event.target.value, searchText: event.target.value, inputValue: event.target.value });
  }

   handleChange = (event) => {
    this.setState({inputValue: event.target.value });
  }

  handlePlaceSelect = (addressObject) => {
    this.setState({
      place: addressObject.name,
      google_place_id: addressObject.place_id
    })
    this.closeHotelsListModal();
  }

  handleLocationSelect = (hotelName, placeId, hotelAddress) => {

   this.setState({
    place: hotelName,
    inputValue:hotelName,
    google_place_id: placeId,
    searchText: hotelName
   })
    isUpdate.push('Update');
    document.getElementById("evName").click();
   this.closeHotelsListModal();
  }
  
  handleShowHotelsList = (event) =>{
    let isValidSearchText = this.state.searchText ? this.state.searchText.trim() : this.state.searchText
    if(!isValidSearchText){
      alert("Please Enter a Location");
      return
    }
    this.setState({
      isLoading: true,
      showHotelsList: true,
      advanceSearchText: this.state.searchText
    })
    let hasSearchPrefs = false;
    this.props.requestHotelSearch(this.state.searchText, hasSearchPrefs, (response)=>{
      let hotelsList = response.results
      hotels = [];
      hotels = (<HotelsListTable
          hotels = {hotelsList}
          handleLocationSelect = {this.handleLocationSelect}
          isAdvanceSearch = {false}
          tableHeader = "Venue"
        />)
      this.setState({
        isLoading: false
      })
    });
  }

  closeHotelsListModal = () =>{
    this.setState({
      showHotelsList: false
    })
  }
  handleLocationChange = (event) =>{
    this.setState({
      searchText: event.target.value
    })
  }
  handleLocationChangeAdvanceSearch = (event) =>{
    this.setState({
      advanceSearchText: event.target.value
    })
  }
  handleAdvanceSearch() {
     this.setState({
      isLoading: true
    })
    this.props.requestHotelAdvanceSearch(this.state.advanceSearchText, (response)=>{
      let hotelsList = response.results
      hotels = [];
      hotels = (<HotelsListTable
          hotels = {hotelsList}
          handleLocationSelect = {this.handleLocationSelect}
          isAdvanceSearch = {true}
          tableHeader = "Venue"
        />)
      this.setState({
        isLoading: false
      })
    })
  }

  render() {
    let detail;
    const spinner = (
      <div className="text-center">
        <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
        <span className="sr-only">Loading...</span>
      </div>
    );
    if (this.props.editing) {
      const initialValues = getInitialValues(this.props.event, this.state.latestEventDate);
      detail = (
        <EventDetailForm
          event={this.props.event}
          initialValues={initialValues}
          removeEvent={this.showConfirmForRemoveEvent}
          showConfirmForEditEvent={this.showConfirmForEditEvent}
          onSubmit={this.handleSubmit}
          place={this.state.place}
          inputValue={this.state.inputValue}
          placeTextBoxChange={this.handlePlaceTextBoxChange}
          handleChange={this.handleChange}
          handlePlaceSelect={this.handlePlaceSelect}
          handleShowHotelsList={this.handleShowHotelsList}
          handleLocationChange={this.handleLocationChange}
          handleLocationSelect={this.handleLocationSelect}
        />
      );
    } else {
      if(this.state.proposalFetched){
        detail = <EventDetail event={this.props.event} tours={this.props.tour} proposals={this.props.proposals} />;
      }
      else{
        detail = <div className="spinner" style={{ display: 'flex', justifyContent: 'center' }} >
            <i className="fa fa-spinner fa-pulse fa-5x fa-fw" />
            <span className="sr-only">Loading...</span>
          </div>
      }
    }
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Event Detail: {this.props.event.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{detail}</Modal.Body>
          <Modal.Footer />
        </Modal>

        {this.state.showConfirmForRemove && (<Modal show={this.state.showConfirmForRemove} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Event</Modal.Title>
          </Modal.Header>
          <Modal.Body>

             <p> {this.state.modalText !== '' ? this.state.modalText : 'Are you sure want to delete event?'}</p>

             <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={this.handleRemoveEvent}
              >
                Delete
              </Button>
              <Button
                bsStyle="dark"
                onClick={this.addFlagForCancel}
              >
                Cancel
              </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}

         {this.state.showConfirmForEdit && (<Modal show={this.state.showConfirmForEdit} onHide={this.closeEditModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Event</Modal.Title>
          </Modal.Header>
          <Modal.Body>

             <p>Do you want to update the stay for these dates as well?<br/><br/>
             Clicking "Yes" will update hotel stays to new dates. You will need to re-send any bids that have already been sent and responded to.</p>

             <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={this.handleConfirmUpdate}                
              >
                Yes
              </Button>
              <Button
                bsStyle="dark"
                form="eventForm"
                type='submit' 
              >
                No
              </Button>
               <Button
                id="stayUpdateConfirmButton"
                form="eventForm"
                type='submit'
              >
                Yes
              </Button>
            </ButtonToolbar><br/>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}

        {this.state.showHotelsList && (<Modal className="hotels-list-modal" show={this.state.showHotelsList} onHide={this.closeHotelsListModal} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Venues</Modal.Title>
          </Modal.Header>
          <Modal.Body>
           <div className="row" style={{padding: '10px'}}>
           <div className="col-sm-12 col-md-6 col-lg-6">
            <input
             id="advanceSearchField"
             className='form-control'
             type="text"
             placeholder="Enter a Location"
             value={this.state.advanceSearchText}
             onChange={this.handleLocationChangeAdvanceSearch}
            />
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4">
            <ButtonToolbar>
             <Button
              bsStyle="success"
              onClick={this.handleAdvanceSearch}
              disabled={this.state.advanceSearchText && this.state.advanceSearchText.trim() !== '' ? false : true}
              >
              Search From Web
            </Button>
          </ButtonToolbar>
          </div>
          </div>
            {!this.state.isLoading ? hotels : spinner}
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>)}
      </div>
    );
  }
}

EventDetailModal.propTypes = {
  tourId: PropTypes.number.isRequired,
  event: PropTypes.object.isRequired,
  proposals: PropTypes.arrayOf(PropTypes.object).isRequired,
  places: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  editing: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  addEvent: PropTypes.func.isRequired,
  editEvent: PropTypes.func.isRequired,
  removeEvent: PropTypes.func.isRequired,
};

export default EventDetailModal;



// WEBPACK FOOTER //
// src/routes/tours/components/EventDetailModal.js